<template>
    <el-container class="mainXxcxBody">
        <el-col class="box">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="mainTitle">交易进度查询</span>
                    <span class="zsText">注：三个查询条件都必须精确输入</span>
                </div>
                <el-form :inline="true" :model="formInline" label-width="110px" class="demo-form-inline" :label-position="labelPosition">
                    <el-row>
                        <el-form-item label="业务大类">
                            <el-select v-model="formInline.ywdl" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务编号">
                            <el-input v-model="formInline.ywbh" placeholder="请输入业务编号"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="受让方">
                            <el-input v-model="formInline.srf" placeholder="受让方/抵押"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <div class="cxzxClass2">
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="resetHt">重置</el-button>
                            </div>
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-card>
            <div v-show="sfxs_ht">
                <el-card class="box-card" :label-position="labelPosition" label-width="80px">
                    <div slot="header" class="clearfix">
                        <span class="mainTitle">查询结果</span>
                    </div>
                    <div>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    业务编号：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jdcxjg.YWXH}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    业务大类：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jdcxjg.YWDL}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    业务细类：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jdcxjg.YWXL}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    转让方：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jdcxjg.ZRF}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    受让方：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jdcxjg.SRF}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    房屋坐落：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jdcxjg.ZL}}
                                </span>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="mainTitle">业务进度</span>
                    </div>
                    <div class="block">
                        <el-timeline :reverse="reverse">
                            <el-timeline-item
                                    v-for="(activity, index) in activities"
                                    :key="index"
                                    :icon="activity.icon"
                                    :type="activity.type"
                                    :color="activity.color"
                                    :size="activity.size"
                                    :timestamp="activity.timestamp">
                                {{activity.content}}
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </el-card>
            </div>
        </el-col>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        data() {
            return {
                labelPosition: 'right',
                sfxs_ht:false,
                formInline: {
                    ywdl:'',
                    ywbh: '',
                    srf: ''
                },
                jdcxjg:{},
                /*jdcxjg: {
                    ywbh: 'YS00000129',
                    ywdl: '商品房交易备案',
                    ywxl: '商品房交易备案(线上)',
                    zrf: '小燕子',
                    srf:'未来房地产公司',
                    fwzl: '雁塔区张巴西街道',
                },*/
                reverse: true,
                activities:[],
                /*activities: [{
                    content: '办结',
                    timestamp: ''
                }, {
                    content: '复审',
                    timestamp: '2018-04-11',
                    icon: 'el-icon-bangzhu',
                    size: 'large',
                    type: 'primary',
                    color: '#00448c'
                }, {
                    content: '受理',
                    timestamp: '2018-04-11',
                    color: '#00448c'
                }, {
                    content: '申请',
                    timestamp: '2018-04-11',
                    color: '#00448c'
                }, {
                    content: '草拟',
                    timestamp: '',
                    color: '#00448c'
                }],*/
                options: [{
                    value: '162280',
                    label: '商品房交易备案'
                }, {
                    value: '162281',
                    label: '存量房交易备案'
                }, {
                    value: '选项3',
                    label: '租赁房交易备案'
                }],
                value: ''
            }
        },
        methods: {
            ...mapActions([
                'HtxxSelect',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                if(this.formInline.ywdl !=""&this.formInline.ywbh !=""&&this.formInline.srf!=""){
                    this.HtxxSelect({_module:'TT',_method:'getJyjd',ywdl:this.formInline.ywdl,ywbh: this.formInline.ywbh,srf:this.formInline.srf}).then((res) => {
                        if (res._result.YwxxList !=null ) {
                            /*业务信息list*/
                            this.jdcxjg=res._result.YwxxList;
                            /*进度信息list*/
                            var arrayObj = new Array();
                            for(let i=0;i<res._result.jyjdList.length;i++){
                                const item1 = {
                                    content: res._result.jyjdList[i].YWBZ,
                                    timestamp:res._result.jyjdList[i].TJSJ,
                                    color:"#00448c"
                                };
                                arrayObj.push(item1)
                            }
                            this.activities=arrayObj;
                            this.sfxs_ht=true;
                        }else{
                            this.warnMessage("没有查到信息，请检查业务大类、业务编号、受让方")
                        }
                    })
                }else{
                    this.warnMessage("业务大类、业务编号、受让方均不能为空");
                }
            },
            resetHt(){
                this.formInline.ywdl='';
                this.formInline.ywbh='';
                this.formInline.srf='';
                this.sfxs_ht=false;
            }
        }
    }
</script>
<style>
    @import "../../assets/css/xxcx/xxcx_main.css";
</style>

